export default {
    LOSE: "Lose",
    MAINTAIN: "Maintain",
    GAIN: "Gain"
  };
  